declare var Highcharts;

// The height of the graph will be 400 if the containing element is not visible when rendered
export function GraphsHighchartController($scope, $element) {
  'ngInject';

  this.render = function () {
    //console.log('highchart.render();');

    $scope.config.chart.renderTo = $element[0];
    this.chart = new Highcharts.Chart($scope.config);
  };

  this.render();

  var self = this;
  $scope.$on('redraw', function () {
    //console.log('highchart.redraw();');
    self.chart.destroy();
    self.render();
  });

  $scope.$on('showLoading', function () {
    self.chart.showLoading();
  });

  $scope.$on('hideLoading', function () {
    self.chart.hideLoading();
  });
}

export function HighchartDirective() {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      config: '='
    },
    template: '<div class="highchart"></div>',
    controller: GraphsHighchartController
  };
}
